<h2 mat-dialog-title i18n="@@pdf-save-data-dialog.title" xmlns="http://www.w3.org/1999/html">Achtung, möglicher Datenverlust</h2>
<div mat-dialog-content>
    <p i18n="@@pdf-save-data-dialog.content">
        Bitte speichern Sie zuerst die Lohnausweise für den Upload im nächsten Jahr.<br/>
        Die Daten werden von der Applikation <b>nicht</b> automatisch gespeichert.
    </p>
</div>
<div mat-dialog-actions class="">
    <button mat-button
            color="primary"
            cdkFocusInitial
            mat-dialog-close
            i18n="@@global.abbrechen"
            mat-button [mat-dialog-close]="false">Abbrechen</button>
    <elohn-xml-export [isMainBar]="false" (exported)="onExported()"></elohn-xml-export>
    <button mat-button
        i18n-matTooltip="@@pdf-save-data-dialog.unsaved-data.tooltip"
        matTooltip="Fortfahren ohne die Daten zu speichern"
        color="primary"
        mat-button [mat-dialog-close]="true"
        i18n="@@pdf-save-data-dialog.unsaved-data">Überspringen</button>
</div>
